import { render, staticRenderFns } from "./HorizontalLaneElement.vue?vue&type=template&id=38b855d8&scoped=true&"
import script from "./HorizontalLaneElement.vue?vue&type=script&lang=js&"
export * from "./HorizontalLaneElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b855d8",
  null
  
)

export default component.exports